import { render, staticRenderFns } from "./audience.vue?vue&type=template&id=f771ac2c&scoped=true"
import script from "./audience.vue?vue&type=script&lang=js"
export * from "./audience.vue?vue&type=script&lang=js"
import style0 from "./audience.vue?vue&type=style&index=0&id=f771ac2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f771ac2c",
  null
  
)

export default component.exports